import React, { useState, useCallback, useRef } from "react";
import SwipeableViews from "react-swipeable-views";
import TeamMemberLinkingContent from "./TeamMemberLinkingContent";
import TeamMemberLinkingForm from "./TeamMemberLinkingForm";

const TeamMemberLinkingSetup = ({ isEmbedded = false }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [stepKey, setStepKey] = useState(0);
  const activeStepRef = useRef(0);

  const handleStepChange = useCallback((step) => {
    activeStepRef.current = step;
    setStepKey((prev) => prev + 1);
  }, []);

  const handleEditItem = useCallback((item) => {
    setSelectedItem(item);
    activeStepRef.current = 1;
    setStepKey((prev) => prev + 1);
  }, []);

  const handleBack = useCallback(() => {
    activeStepRef.current = 0;
    setStepKey((prev) => prev + 1);
    setSelectedItem(null);
  }, []);

  const handleSuccess = useCallback(() => {
    // After successful submit, go back to list view
    activeStepRef.current = 0;
    setStepKey((prev) => prev + 1);
    setSelectedItem(null);
  }, []);

  return (
    <SwipeableViews
      key={stepKey}
      enableMouseEvents={false}
      index={activeStepRef.current}
      onChangeIndex={handleStepChange}
    >
      <TeamMemberLinkingContent
        isEmbedded={isEmbedded}
        onEditItem={handleEditItem}
      />
      <TeamMemberLinkingForm
        initialData={selectedItem}
        onBack={handleBack}
        onSuccess={handleSuccess}
      />
    </SwipeableViews>
  );
};

export default TeamMemberLinkingSetup;
